import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "../Styles/ContactPage.css";

const ContactPage = () => {
  const location = useLocation();
  const headingRef = useRef(null);

  // form states
  const [formData, setFormData] = useState({
    firstname: "",
    phone: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    if (location.state?.highlight === "contact" && headingRef.current) {
      headingRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      headingRef.current.classList.add("highlight-section");
      setTimeout(() => headingRef.current.classList.remove("highlight-section"), 2000);
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { firstname, phone, email, message } = formData;

    if (!firstname || !phone || !message) {
      alert("Please fill out all required fields (name, phone, message).");
      return;
    }

    const whatsappNumber = "2347030792420"; // ✅ full international format, no '+'
    const text = `Hello T-Rides,%0A
Name: ${firstname}%0A
Phone: ${phone}%0A
Email: ${email || "N/A"}%0A
Message: ${message}`;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${text}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <main className="contact-page">
      {/* LEFT: LEAFLET MAP */}
      <div className="contact-map">
        <MapContainer center={[48.8566, 2.3522]} zoom={13} style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[48.8566, 2.3522]}>
            <Popup>📍 41 Gade Street Gwarinpa Abuja, FCT.</Popup>
          </Marker>
        </MapContainer>
      </div>

      {/* RIGHT CONTENT */}
      <div className="contact-content">
        <h2 className="contact-heading">Do You Require A Car?</h2>
        <h3 className="contact-subheading" ref={headingRef}>
          Get In Touch With Us
        </h3>
        <p className="contact-tagline">Finest car rental</p>
        <p className="contact-description">
          Suspendisse in est ante in nibh mauris cursus mattis molestie laoreet id
          donec ultrices tincidunt arcu non sodales neque.
        </p>

        {/* CONTACT INFO */}
        <div className="contact-info">
          <p>📞 Phone: (234) 703 0792 420</p>

          <div className="contact-info-group">
            <p>✉️ oyeanthony@gmail.com</p>
            <p>📍 41 Gade Street Gwarinpa Abuja, FCT.</p>
          </div>

          <p>⏰ Mon - Sat : 09:00-23:00; Sunday closed</p>
        </div>

        {/* FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h4>Leave a Comment</h4>

          {/* Name + Phone same row */}
          <div className="form-row">
            <input
              type="text"
              name="firstname"
              placeholder="Your Firstname"
              value={formData.firstname}
              onChange={handleChange}
              required
            />
            <input
              type="number"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <input
            type="email"
            name="email"
            placeholder="Email (optional)"
            value={formData.email}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Your message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit">Send</button>
        </form>
      </div>
    </main>
  );
};

export default ContactPage;
